
import { ViewerEvent }     from './viewer.event';
import {
  BrowserEventType,
  ViewerEventType
}                    from "./viewer.event.type";

/**
 *
 * @class EventBuilder
 *
 * helper for creating events
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2023
 *
 */
export class EventBuilder {

  /** unique ids for events */
  private static id: number                   = 0;

  /** the original browser even (if appropriate */
  public original: BrowserEventType           = null;

  /** the kind of event */
  public type: ViewerEventType                = ViewerEventType.NONE;

  /** milliseconds timestamp */
  public timestamp: number                    = 0;

  /** any custom data for the event */
  public data: any                            = {};

  /** fetch the original browser event; won't exist for all possible events */
  public getOriginalEvent(): BrowserEventType {

    return this.original;
  }

  /** force the original event */
  public setOriginalEvent(event: BrowserEventType): EventBuilder {

    this.original = event;

    return this;
  }

  /** fetch the event type */
  public getType(): ViewerEventType {

    return this.type;
  }

  /** force the even type */
  public setType(type: ViewerEventType): EventBuilder {

    this.type = type;

    return this;
  }

  /** fetch the timestamp */
  public getTimestamp(): number {

    return this.timestamp;
  }


  /** force the timestamp */
  public setTimestamp(timestamp: number): EventBuilder {

    this.timestamp = timestamp;

    return this;
  }

  /** fetch any custom event data */
  public getData(): any {

    return this.data;
  }

  /** force the custom event data */
  public setData(data: any): EventBuilder {

    this.data = data;

    return this;
  }

  /** create a new event */
  public build(): ViewerEvent {

    let b: EventBuilder = this;

    let timestamp: number = b.timestamp;

    if (timestamp == 0) {

      timestamp = performance.now();
    }

    EventBuilder.id++;

    let event:ViewerEvent = new ViewerEvent({
      id:        EventBuilder.id,
      original:  b.original,
      type:      b.type,
      timestamp,
      data:      b.data
    });

    /* reset */

    b.original  = null;
    b.type      = ViewerEventType.NONE;
    b.timestamp = 0;
    b.data      = {};

    /* pass it back */

    return event;
  }
}
